import React, { useEffect, useState } from "react";
import "./DashboardPage.css";
import MealTimeline from "./meal-timeline/MealTimeline";
import { getCurrentMealPlan, getMealPlanPreference } from "../../api/OtterApi";
import { useAuth0 } from "@auth0/auth0-react";

const DashboardPage = () => {
    const [mealPlan, setMealPlan] = useState({});
    const { getAccessTokenSilently } = useAuth0();
    const [currentMealplanId, setCurrentMealplanId] = useState();

    useEffect(() => {
        const initializeCurrentMealPlanID = async () => {
            const token = await getAccessTokenSilently();
            const getCurrentMealPlanResponse = await getCurrentMealPlan(token);
            if (getCurrentMealPlanResponse.status === 200) {
                setCurrentMealplanId(
                    getCurrentMealPlanResponse.data.mealplan_id
                );
            } else {
                console.error(getCurrentMealPlanResponse.data.error);
            }
        };
        initializeCurrentMealPlanID();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const initializeMealPlan = async () => {
            const token = await getAccessTokenSilently();
            const response = await getMealPlanPreference(
                token,
                currentMealplanId
            );
            if (response.status === 200) {
                setMealPlan(response.data.mealplan);
            } else {
                console.error(response.data.error);
            }
        };
        if (currentMealplanId) {
            initializeMealPlan();
        }
    }, [currentMealplanId, getAccessTokenSilently]);

    return (
        <div className="dashboard-container">
            <div className="dashboard-header-container">
                <h1>Today</h1>
            </div>
            <div className="meal-timeline-container">
                <MealTimeline plannedMeals={mealPlan.planned_meals} />
            </div>
        </div>
    );
};

export default DashboardPage;
